module.exports = __webpack_public_path__ + "img/ticket.d9fbf048.svg";